import { render } from "./ClinicalHistorySection.vue?vue&type=template&id=901936e4&ts=true"
import script from "./ClinicalHistorySection.ts?vue&type=script&lang=ts&external"
export * from "./ClinicalHistorySection.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__